import { DeviceModelOutputData } from './device-model-output-data.model';


export class DeviceBrandOutputWithStatusAndDeviceModel implements IDeviceBrandOutputWithStatusAndDeviceModel {
    /** The auto-generated id of the device brand  master */
    device_brand_id!: number;
    /** The device brand name with 255 character limit */
    device_brand_name!: string;
    /** Manage status of device brand. 0 For De-active, 1 For Active */
    status!: number;
    device_model!: DeviceModelOutputData[];

    constructor(data?: IDeviceBrandOutputWithStatusAndDeviceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_brand_id = _data["device_brand_id"];
            this.device_brand_name = _data["device_brand_name"];
            this.status = _data["status"];
            if (Array.isArray(_data["device_model"])) {
                this.device_model = [] as any;
                for (let item of _data["device_model"])
                    this.device_model!.push(DeviceModelOutputData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceBrandOutputWithStatusAndDeviceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceBrandOutputWithStatusAndDeviceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_brand_id"] = this.device_brand_id;
        data["device_brand_name"] = this.device_brand_name;
        data["status"] = this.status;
        if (Array.isArray(this.device_model)) {
            data["device_model"] = [];
            for (let item of this.device_model)
                data["device_model"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceBrandOutputWithStatusAndDeviceModel {
    /** The auto-generated id of the device brand  master */
    device_brand_id: number;
    /** The device brand name with 255 character limit */
    device_brand_name: string;
    /** Manage status of device brand. 0 For De-active, 1 For Active */
    status: number;
    device_model: DeviceModelOutputData[];
}

